import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';
import customFetchBase from '../expiredToken/expiredToken';
import {
  ITrimLight,
  XseriesConfig
} from '../../types/Lights/trimLightInterfaces';
import {
  FeaturesArray,
  ILightZone
} from '../../types/Lights/lightZoneInterfaces';

const customFetch = customFetchBase(config.baseUrlDealers);

export const apiLightsZones = createApi({
  baseQuery: customFetch,
  endpoints: (builder) => ({
    getLightsZonesByLocation: builder.mutation<ILightZone[], number>({
      query: (locationId) => ({
        url: `api/LightAndZones/OrderedList/${locationId}`,
        method: 'GET'
      })
    }),
    updateLightName: builder.mutation<
      void,
      { lightId: number; name: string; pinName: string }
    >({
      query: (body) => ({
        url: `api/Light/UpdateName`,
        method: 'PUT',
        body
      })
    }),
    updateChannelName: builder.mutation<
      void,
      { lightId: number; name: string }
    >({
      query: (body) => ({
        url: `api/ChannelConfiguration/Name/${body.lightId}`,
        method: 'PUT',
        body: { name: body.name }
      })
    }),
    getConfigurationId: builder.mutation<XseriesConfig, number>({
      query: (lightId) => ({
        url: `api/ChannelConfiguration/${lightId}`,
        method: 'GET'
      })
    }),
    getLightCapability: builder.mutation<FeaturesArray, number>({
      query: (lightId) => ({
        url: `api/Light/Capabilities/${lightId}`,
        method: 'GET'
      })
    }),
    deleteZones: builder.mutation<{}, { id: number[] }>({
      query: (data) => ({
        url: `api/Zone?Ids=${data.id.join(',')}`,
        method: 'DELETE'
      })
    })
  })
});

export const {
  useGetLightsZonesByLocationMutation,
  useUpdateLightNameMutation,
  useUpdateChannelNameMutation,
  useGetConfigurationIdMutation,
  useGetLightCapabilityMutation,
  useDeleteZonesMutation
} = apiLightsZones;
